import type { SEOPropsType } from '..';

export const SEO_METRONIDAZOLE_CONTENT: SEOPropsType = {
  title: 'Metronidazole Prescription - Curology Custom Formula',
};
